<template>
  <div class="snapshot-wrapper" :class="selectedSnapshot && selectedSnapshot.id === snapshot.id ? 'selected' : ''">

    <button class="snapshot__delete-button" @click="deleteSnap">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
    </button>


    <form @submit.prevent="removeFocus">
      <input :ref="snapshot.id" name="snapshot-name" class="snapshot__input snapshot__input--title text-right" type="text" v-model="snapshot.title">
      <label class="snapshot__help-text" for="snapshot-name">Rename</label>
    </form>

    <picture @click="load" class="snapshot__picture">
      <img  class="block" :src="snapshot.src || snapshot.image" alt="snapshot image" width="80">
    </picture>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "Snapshot",
    props: {
      snapshot: {
        type: Object,
        required: true,
      }
    },
    computed: {
      ...mapGetters('snapshots',[
        'selectedSnapshot',
      ])
    },
    methods: {
      ...mapActions('snapshots',[
        'loadSnapshot',
        'deleteSnapshot'
      ]),
      load() {
        // console.log(this.snapshot);
        this.loadSnapshot(this.snapshot);
      },
      removeFocus() {
        this.$refs[this.snapshot.id].blur();
      },
      deleteSnap() {

        if(confirm('Delete Snapshot?')) {

          this.deleteSnapshot(this.snapshot);

        }

      }
    },
  }
</script>

<style scoped>
  .snapshot-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border: 1px solid transparent;
    opacity: 0.5;
    position: relative;
  }

  .snapshot-wrapper.selected, .snapshot-wrapper:hover {
    opacity: 1;
  }

  .snapshot-wrapper form {
    width: calc(100% - 80px);
    position: relative;
  }

  .snapshot__input {
    width: 100%;
    padding: 4px 10px;
    font-size: 14px;
    border: 1px solid transparent;
    border-radius: 0px;
    margin-right: 15px;
  }

  .snapshot__picture {
    width: 80px;
    height: 80px;
    padding: 5px;
    display: flex;
    align-items: center;
  }
  .snapshot__picture img {
    height: 70px;
    width: 70px;
    border-radius: 70px;
    object-fit: cover;
    cursor: pointer;
  }

  .snapshot__input:hover {
    border-bottom-color: #DDDDDD;
  }

  .snapshot__input:focus {
    border-bottom-color: red;
    outline: none;
  }

  .snapshot__help-text {
    position: absolute;
    text-align: right;
    color: #7C7C7C;
    font-size: 12px;
    font-style: italic;
    padding-top: 3px;
    opacity: 0;
    width: 100%;
    display: block;
    transition: all 0.3s ease-in-out;
  }

  .snapshot__input + label {
    padding-right: 10px;
    padding-top: 0px;
  }

  .snapshot__input:focus + label, .snapshot__input:hover + label {
    opacity: 0.8;
    padding-top: 6px;
    padding-right: 10px;
  }

  .snapshot__delete-button {
    position: absolute;
    z-index: 999;
    border-radius: 50px;
    width: 24px;
    height: 24px;
    color: #7C7C7C!important;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 5px;
    opacity: 0.8;
    right: 5px;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.2) ;
    transition: all 0.3s ease-in-out;
  }

  .snapshot__delete-button:hover {
    color: red!important;
    opacity: 1;
  }

</style>